export const Strings = {
    ACCOUNT: 'Account',
    BACK: 'Back',
    CHANGE_PASSWORD: 'Change password',
    CLOSE: 'Close',
    CODE: 'Code',
    CONFIRM_PASSWORD: 'Confirm password',
    CONFIRM_PASSWORD_NOT_MATCH: 'Password and confirm password mismatches',
    CREATE_USER: 'Create user',
    CURRENT_PASSWORD: 'Current password',
    CURRENT_PASSWORD_IS_INVALID: 'Current password is invalid',
    CURRENT_PASSWORD_IS_REQUIRED: 'To change the password, current password is required',
    EMAIL: 'E-mail',
    FIRST_NAME: 'Firts name',
    FIRST_NAME_REQUIRED: 'First name is required',
    FORGET_PASSWORD: 'Forget password?',
    GENERAL_REQUEST_ERROR: 'The request failed or server is offline',
    GET_CODE_FROM_EMAIL: 'Get the recovery code from your email and input it here',
    ID: 'ID',
    INVALID_DUPLICATE_EMAIL: 'Username is exists',
    INVALID_EMAIL: 'E-mail is invalid',
    INVALID_LOGIN: 'Invalid username or password',
    INVALID_PASSWORD: 'Password must be at lease 6 characters and contain at lease 1 uppercase and 1 lowercase character',
    LAST_NAME: 'Last name',
    LOADING: 'Loading...',
    LOGIN: 'Login',
    LOGIN_AS: 'Login as',
    LOGOUT: 'Logout',
    NAME: 'Name',
    NEW_PASSWORD: 'New password',
    PASSWORD: 'Password',
    RECOVERY_PASSWORD: 'Recovery Password',
    RECOVERY_PASSWORD_SUCCESS: 'Recovery Password Success',
    RECOVERY_PASSWORD_SUCCESS_MESSAGE: 'Your password has been recovered!',
    SAVE: 'Save',
    SAVE_ACCOUNT_SUCCESS: 'Save account success',
    SUBMIT: 'Submit',
    UNABLE_TO_RECOVERY_PASSWORD: 'Unable to recovery the password. Please try again.',
    USER_NAME: 'Username',
    USERS: 'Users'
};
